document.addEventListener("DOMContentLoaded", function (event) {
  // Init
  tippy("[data-tippy-content]");

  tippy(".bid__coeff--1x", {
    content: `<img class="bid__tippy__img" width="72" height="11"
src="app/images/dest/bid/1xstavka.svg" alt="1xstavka" title="1xstavka" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".forecasts__item__top__score--1x", {
    content: `<img class="forecasts__tippy__img" width="72" height="11"
src="app/images/dest/bid/1xstavka.svg" alt="1xstavka" title="1xstavka" title="1xstavka" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item--ggbet", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/ggbet.png" alt="ggbet" title="ggbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item--leon", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/leon.png" alt="leon" title="leon" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item--parimatch", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/parimatch.png" alt="parimatch" title="parimatch" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item__wrapper--winline", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/winline.png" alt="winline" title="winline" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item__wrapper--mostbet", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/mostbet.png" alt="mostbet" title="mostbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".matches__stats__item__wrapper--melbet", {
    content: `<img class="bid__tippy__img" width="72"
src="app/images/new__design/BK/melbet.png" alt="melbet" title="melbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--1xstavka", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/1xstavka.svg" alt="1xstavka" title="1xstavka" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--888", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/888.svg" alt="888" title="888" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--365", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/365.svg" alt="365" title="365" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--astrabet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/astrabet.svg" alt="astrabet" title="astrabet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--baltbet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/baltbet.svg" alt="baltbet" title="baltbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--betboom", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/betboom.svg" alt="betboom" title="betboom" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--betcity", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/betcity.svg" alt="betcity" title="betcity" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--fonbet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/fonbet.svg" alt="fonbet" title="fonbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--ivanbet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/ivanbet-logo.svg" alt="ivanbet" title="ivanbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--leon", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/leon.svg" alt="leon" title="leon" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--liga_stavok", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/liga_stavok.svg" alt="liga stavok" title="liga stavok" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--marathon", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/marathon.svg" alt="marathon" title="marathon" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--melbet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/melbet.svg" alt="melbet" title="melbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--olimp", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/olimpbet.svg" alt="olimp" title="olimp" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--paribet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/paribet-logo.svg" alt="paribet" title="paribet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--pari", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/pari-new.svg" alt="Пари" title="Пари" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--zenit", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/zenit.svg" alt="zenit" title="zenit" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--tennisi", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/tennisi.svg" alt="tennisi" title="tennisi" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--sportbet", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/sportbet-logo.svg" alt="sportbet" title="sportbet" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy(".js-tippy-bk--winline", {
    content: `<img class="bid__tippy__img" width="72" height="32px"
    src="https://cdn.online-bookmakers.ru/static/img/bklogo/svg/winline.svg" alt="winline" title="winline" loading="lazy">`,
    allowHTML: true,
    theme: "bukmekerz",
  });

  tippy("[data-template]", {
    content(reference) {
      const id = reference.getAttribute("data-template");
      const template = document.getElementById(id);
      return template.innerHTML;
    },
    placement: "right",
    arrow: false,
    allowHTML: true,
    theme: "forecasts",
  });
});
